import { Component } from '@angular/core';

@Component({
  selector: 'uss-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
